// Change the fallback string below to switch environments. Restart dev server after.
// Local: "http://127.0.0.1:8000"
// Dev:   "https://api.dev.ai2peat.ie"
export const API_BASE_URL = (
  process.env.NEXT_PUBLIC_API_BASE_URL ?? "https://api.dev.ai2peat.ie"
).replace(/\/$/, "");

export const STATS_API_URL =
  process.env.NEXT_PUBLIC_STATS_API ?? `${API_BASE_URL}/api/statistics/`;
